import { CallbackRegistry, UnsubscribeFunction } from "callback-registry";
import { Glue42Office } from "../../glue4office";
import { DocumentEvents, HtmlReceiveInvocationResult, InternalDocumentApi } from "./types";
import { Glue42Core } from "@glue42/core";
import { ReturnHtmlMethodName, OnReturnHtmlMethodName } from "./const";

const CallbackFactory = require("callback-registry");

export default (cookie: string, config: Glue42Office.Word.OpenDocumentConfig, agm: Glue42Core.AGM.API): InternalDocumentApi => {
    const _registry: CallbackRegistry = CallbackFactory();

    const name = config.name;
    const data = config.data;
    let _html = "";
    let _docx = "";
    let getHtmlPromise: any;

    function onClose(callback: () => void): UnsubscribeFunction {
        return _registry.add("on-closed", callback);
    }

    function _close(): void {
        _registry.execute("on-closed");
    }

    function getHtml(callback: (html: string) => void): Promise<string> {
        return new Promise((resolve, reject) => {
            agm.invoke(ReturnHtmlMethodName, {
                cookie,
                callbackMethod: OnReturnHtmlMethodName,
            });
            getHtmlPromise = resolve;
        });
    }

    function onChanged(callback: (html: string, docx?: string) => void): UnsubscribeFunction {
        return _registry.add("on-changed", callback);
    }

    function _combineChunks(newData: HtmlReceiveInvocationResult, cb: (html: string, docx: string) => void): void {
        // We have all document in one chunk
        if (newData.length === newData.totalLength && newData.lengthDocx === newData.totalLengthDocx) {
            _html = newData.html;
            _docx = newData.docx;
            cb(_html, _docx);
        } else {
            // We have multiple chunks
            if (newData.offset === 0) {
                _html = "";
            }
            if (newData.offsetDocx === 0) {
                _docx = "";
            }

            if (newData.html && newData.html.length > 0) {
                _html = _html.substr(0, newData.offset) + newData.html +
                    _html.substr(newData.offset + newData.length);
            }
            if (newData.docx && newData.docx.length > 0) {
                _docx = _docx.substr(0, newData.offsetDocx) + newData.docx +
                    _docx.substr(newData.offsetDocx + newData.lengthDocx);
            }

            const docxTotal = newData.totalLengthDocx || 0;

            if ((newData.totalLength === _html.length) &&
                (docxTotal === 0 || docxTotal === _docx.length)) {
                // Execute when all chunks are received
                cb(_html, _docx);
            }
        }
    }

    function _onHtml(newData: HtmlReceiveInvocationResult): void {
        _combineChunks(newData, (html, docx) => {
            getHtmlPromise(html);
        });

    }

    function _onChanged(newData: HtmlReceiveInvocationResult): void {
        _combineChunks(newData, (html, docx) => {
            api.data = html;
            _registry.execute("on-changed", api.data, docx);
        });
    }

    const api: Glue42Office.Word.DocumentApi = {
        name,
        data,

        getHtml,
        onClose,
        onChanged,
    };

    const events: DocumentEvents = {
        _onChanged,
        _close,
        _onHtml,
    };

    return {
        documentApi: api,
        documentEvents: events,
    };
};
